import React, {useState} from "react";
import styles from "./styles.module.scss"
import Button from "../Button";
import jumpToChat from "../../utils/jumpToChat";
import {Link} from "react-router-dom"
import {useModal} from "../RegModal/ModalContext";

function Footer () {
  const { showModal } = useModal();

  const [show, setShow] = useState(false)

  const scroll = () => {
    window.scrollTo(0, 0);
  }

  return <>
    <section className={styles.xianjianSection}>
      <h2>立即体验全新一代科创金融数据库</h2>
      <div className={styles.links}>
        <Button width="284px" onClick={() => showModal()} withArrow>立即体验</Button>
        <Button onClick={() => {window.open("https://vip.xiniudata.com/")}}>PC版</Button>
      </div>
    </section>
    <footer>
      <div className={styles.footerContent}>
        <div>
          <div className={styles.inlineBlock}>
            <img src="/static-official/images/invite-qrcode.png" width={130} height={130}/>
            <p className={styles.mt15}>扫码免费试用</p>
          </div>
          <div className={styles.inlineBlock}>
            <img src="/static-official/images/logo-footer.svg" className={styles.logo} alt="xiniudata logo" />
            <p>业务合作：hello@xiniudata.com</p>
            <p>加入我们：hr@xiniudata.com</p>
            <p>
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
                沪ICP备16014930号
              </a>
            </p>
            <p>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402007563" target="_blank" rel="noreferrer">
                沪公网安备 31010402007563号
              </a>
            </p>
            <p>© 2024 <a onClick={() => {setShow(true)}}>免责声明</a></p>
          </div>
        </div>

        <div className={styles.links}>
          <h4>解决方案</h4>
          <Link to="/solutions/a">私募股权投资</Link>
          <Link to="/solutions/b">政府招商引资</Link>
          <Link to="/solutions/c">银行科创金融</Link>
          <Link to="/solutions/d">券商科创金融</Link>
          <br />
          <br />
          <br />

          <div className={styles.link_menus}>
            <Link to="/" ><h4 onClick={scroll}>首页</h4></Link>
            <a onClick={() => {jumpToChat()}} ><h4>烯牛先见</h4></a>
            <Link to="/productions" ><h4>产品</h4></Link>
            <Link to="/data" ><h4>数据</h4></Link>
            <Link to="/research" ><h4>烯牛研究院</h4></Link>
            <a href="#/mcp" target="_blank" rel="noreferrer"><h4>烯牛MCP</h4></a>
          </div>
        </div>
      </div>
    </footer>
    {show ? <div className={styles.modal_wrapper}>
      <div className={styles.modal_backdrop}/>
      <div className={styles.modal}>
        <div className={styles.modal_inner}>
          <div className={styles.content}>
            <div>
              <div className={styles.section_header}>免责声明</div>
              <div className={styles.section_content}><p>烯牛数据所登载的信息均来自于<b>网络公开信息</b>，烯牛数据仅做收集并向用户进行展示。</p>
                <p>限于技术水平、各信息来源网站更新不同步等原因，此类信息的展示并不视为烯牛数据对其内容的真实性、准确性、完整性、时效性作出任何形式的确认或担保。</p>
                <p>请您在依据烯牛数据提供的相关信息服务作出任何判断或决策前，自行进一步核实此类信息的完整或准确性，并自行承担使用后果。
                  同时烯牛数据也将继续提升技术水平，不断完善信息来源与质量，为您提供更高质量的服务。</p></div>
            </div>
          </div>
        </div>
        <div className={styles.modal_close_button} onClick={() => {setShow(false)}}>
          <svg fill="#858A99" viewBox="0 0 24 24" width="24" height="24"
               className="jsx-1450592414 modal_close_icon__2nks3HZG">
            <path
              d="M13.486 12l5.208-5.207a1.048 1.048 0 0 0-.006-1.483 1.046 1.046 0 0 0-1.482-.005L12 10.514 6.793 5.305a1.048 1.048 0 0 0-1.483.005 1.046 1.046 0 0 0-.005 1.483L10.514 12l-5.208 5.207a1.048 1.048 0 0 0 .006 1.483 1.046 1.046 0 0 0 1.482.005L12 13.486l5.207 5.208a1.048 1.048 0 0 0 1.483-.006 1.046 1.046 0 0 0 .005-1.482L13.486 12z"
              fillRule="evenodd" className="jsx-1450592414"></path>
          </svg>
        </div>
      </div>
    </div> : null}
  </>
}

export default Footer
